module.exports = __webpack_public_path__ + "static/logo-ac069db89f7aa8ba7462b5e9f81c1c74.svg";